import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_97986a72: FaireBrandEntity = {
  token: "b_97986a72",
  type: "brand",
  name: "Sevya Handmade",
  avatarUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/a42f34d3ce1ce9d7a60405b1c2c8695e66b4a84f36963afd6cd7cc70cc40db64/1555450027.jpg",
  bannerUrl:
    "https://cdn.faire.com/fastly/b591ad7b247512f2f07016292f56a08f0c43b09042682a61ecbeec47e2291f15.jpeg",
  logoUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/a42f34d3ce1ce9d7a60405b1c2c8695e66b4a84f36963afd6cd7cc70cc40db64/1555450027.jpg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b591ad7b247512f2f07016292f56a08f0c43b09042682a61ecbeec47e2291f15.jpeg",
  location: "Ladson, SC, USA",
  minimumOrderDollars: 90,
  rating: 5,
  reviewCount: 1105,
  isTopShop: true,
  isInsider: true,
  description:
    '"Sevya" is a Sanskrit word that means "caring through service"; caring for humanity and for the environment we live in.  Sevya is dedicated to preserving the indigenous art forms and cultures of India by supporting the artisan communities who uphold these traditions. \n\nWe work directly with artisan communities throughout India to develop contemporary styles of apparel & accessories that showcase their traditional and eco-friendly methods of handcraft--including hand-loom, block-printing, tie-dye, and embroidery. Our collection of fair trade apparel, accessories, and home linens are made with the finest natural materials using traditional craft techniques, which are passed down from generation to generation. By providing a sustainable livelihood to these artisan communities, we help to ensure that these artisans, and their craft traditions, can continue to flourish. Sevya is a member of the Fair Trade Federation.',
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:10.062Z",
    importedBy: "entity-db-cli",
  },
};
